<template>
  <div style="display: flex; flex-direction: column; align-items: flex-start">
    <div class="d-flex">
      <management-button
        v-if="isTaskBlocked"
        class="map-button"
        type="execute"
        :label="$t('Show Message')"
        @buttonClick="showErrorMsg"
      />
      <management-button
        v-if="taskDecisionButtons || isTaskBlocked"
        class="map-button"
        type="execute"
        :label="$t('Submit')"
        @buttonClick="submit"
        :disabled="taskDecisionButtons ? taskContents.length !== tasks.length : !(taskContents.length > 0)"
      />
    </div>
    <v-layout wrap :class="isMixedTask ? 'image-effect' : 'image-effect ml-2'">
      <v-card
        width="300"
        striped
        @click="openImageView(task)"
        :class="isMixedTask ? 'mt-3 pa-2 elevation-2' : 'ma-3 pa-2 elevation-2'"
        v-for="task of tasks"
        :key="task.id"
      >
        <v-img
          v-if="task.value"
          :src="task.value"
          :alt="task.label"
          max-height="200px"
          width="300px"
          contain
          loading
          transition="fade-transition"
        />
        <v-card-title>
          <span>
            <v-icon v-if="task.blocked" color="error">
              priority_high
            </v-icon>
            {{ task.label }}
          </span>
          <task-decision-buttons
            v-if="taskDecisionButtons || isTaskBlocked"
            @approve="
              $emit('updateTaskContents', {
                decision: 'approve',
                uuid: task.uuid
              })
            "
            @reject="
              $emit('updateTaskContents', {
                decision: 'reject',
                uuid: task.uuid
              })
            "
            :isTaskBlocked="isTaskBlocked"
            :uuid="task.uuid"
            :taskContents="taskContents"
          />
        </v-card-title>
      </v-card>
      <photo-view
        v-if="imageData"
        :dialog="dialog"
        :imageData="imageData"
        @close="closeImageView($event)"
        @updateTaskContents="$emit('updateTaskContents', $event)"
        :taskContents="taskContents"
        :taskDecisionButtons="taskDecisionButtons"
      />
    </v-layout>
    <text-message :textDialog="textDialog" :text="textMsg" @closeTextDialog="closeTextDialog"/>
    <app-dialog-box
      :open="rejectDialog"
      :title="$t('RejectTask')"
      :content="$t('RejectionMessage') + '*'"
      :main-action-label="$t('Cancel')"
      @mainAction="cancelRejection"
      :secondary-action-label="$t('Reject')"
      :secondary-action-disable="rejectionMessage.trim().length !== 0"
      @secondaryAction="rejectTask"
      :loading="loadingDelete"
    >
      <div slot="dialog-textbox" class="rejection-message-textarea">
        <textarea
          v-model="rejectionMessage"
          class="input-field"
          maxlength="1024"
        />
        <label>{{ $t("RejectionNote") }}</label>
      </div>
    </app-dialog-box>
  </div>
</template>

<script>
import PhotoView from "./PhotoView.vue";
import TaskDecisionButtons from "@/components/FieldManagement/FieldWork/Data/TaskDecisionButtons";
import AppDialogBox from "@/components/_Molecules/AppDialogBox";
import ManagementButton from "@/components/Management/ManagementButton";
import TextMessage from './TextMessage.vue';
export default {
  name: "photos",

  components: {
    PhotoView,
    TaskDecisionButtons,
    AppDialogBox,
    ManagementButton,
    TextMessage
  },

  props: {
    tasks: {
      type: Array,
      required: true
    },

    loading: {
      type: Boolean
    },

    taskDecisionButtons: {
      type: Boolean,
      default: false
    },
    taskContents: {
      type: Array
    },
    isMixedTask: {
      type: Boolean,
      default: false
    },
    isTaskBlocked:{
      type: Boolean,
      default: false
    },
    blockMessage:{
      type: String,
    }
  },

  data() {
    return {
      dialog: false,
      imageData: [],
      rejectDialog: false,
      loadingDelete: false,
      rejectionMessage: "",
      textDialog: false,
      textMsg: ""
    };
  },

  methods: {
    openImageView(imageData) {
      this.imageData = imageData;
      this.dialog = true;
    },

    closeImageView(closeImage) {
      this.dialog = closeImage;
      this.imageData = [];
    },

    cancelRejection() {
      this.rejectDialog = false;
      this.rejectionMessage = "";
    },

    rejectTask() {
      this.$emit("rejectTask", this.rejectionMessage);
      this.cancelRejection();
    },

    submit() {
      if (
        this.taskContents.filter(item => item.decision === "reject").length > 0
      ) {
        this.rejectDialog = true;
      } else {
        this.$emit("approveTask");
      }
    },
    showErrorMsg(){
      this.textDialog = true;
      this.textMsg = this.blockMessage;
    },
    closeTextDialog(){
      this.textDialog = false;
      this.textMsg = "";
    }
  }
};
</script>

<style>
tr.expand .v-expansion-panel .image-effect {
  border: none;
  box-shadow: 0 0 5px 0 gray;
}
tr.expand .v-expansion-panel .image-effect:hover {
  cursor: pointer;
  transform: scale(1.04);
}
tr.expand .v-expansion-panel .image-effect:active {
  transform: scale(0.99);
}
</style>



// WEBPACK FOOTER //
// src/components/FieldManagement/FieldWork/Data/TaskType/Photos.vue